import React, {Component} from 'react';

class NotifyKS extends Component {
	constructor(props) {
		super(props);

		this.state = {
			autohide: true
		};
	}

	static getDerivedStateFromProps(props) {
		if (props.autohide === undefined || !!props.autohide) {
			return null;
		} else {
			return {
				autohide: false
			}
		}
	}

	defineNotificationType() {
		let type = this.props.type;
		let style = {};

		switch (type) {
			case 'success':
				style.background = '#8ad68a';
				break;

			case 'error':
				style.background = '#d68a8a';
				break;

			case 'warning':
				style.background = '#d6cd8a';
				break;

			case 'info':
				style.background = '#8ab9d6';
				break;
		}

		if (this.props.timeout) {
			style.animationDelay = this.props.timeout.toString() + 's';
		}

		return style;
	}

	defineLabelStyle() {
		let style = {};

		if (this.props.timeout) {
			style.animationDelay = this.props.timeout.toString() + 's'
		}

		return style;
	}

	defineClassName(target) {
		if (this.state.autohide) {
			return 'notify' + target + ' ' + 'temp';
		} else {
			return 'notify' + target;
		}
	}

	render() {
		return (
			<div className={this.defineClassName('Container')} style={this.defineNotificationType()}>
				{this.props.message &&
				<label className={this.defineClassName('Label')} style={this.defineLabelStyle()}>{this.props.message}</label>}

				{this.props.html &&
				<div style={{padding: '0', margin: '5px 0 0 0'}}>
					{this.props.html}
				</div>}
			</div>
		)
	}
}

export default NotifyKS;